import "./style.css";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {LicenseTypeList} from "../constants/License.type";
import {GET_CAPACITY} from "../../../constants/query/License.query";
import {GRAPHQL, UPDATE_LICENSE} from "../../../constants/ApiUrl";
import {CapacityDto} from "../dto/Capacity.dto";
import DatePicker from "react-datepicker";
import {ko} from "date-fns/esm/locale";
import {InitialLicenseDetailDto, LicenseDetailDto} from "../dto/LicenseDetail.dto";
import {getLimitDate} from "../../../util/DatePickerUtil";
import {DateParser} from "../../../util/DateParser";
import close from "../../../assets/images/close.svg";

export default function Edit(props: any) {
    const [licenseInfo, setLicenseInfo] = useState<LicenseDetailDto>(InitialLicenseDetailDto);

    useEffect(() => {
        axios.post(GRAPHQL, {query: GET_CAPACITY(props.userSeq, props.license.licenseCode)})
            .then(response => {
                createInfo(response.data.data.getCapacityInfo);
            }).catch(error => console.log(error));
    }, []);

    const createInfo = (capacityInfo: CapacityDto) => {
        setLicenseInfo(prevState => ({
            ...prevState,
            subscriptionSeq: props.license.subscriptionSeq,
            licenseType: props.license.licenseCode,
            isActive: props.license.isActive,
            startAt: props.license.startAt,
            nextRenewalAt: props.license.nextRenewalAt,
            capacity: capacityInfo.capacity,
            count: capacityInfo.count
        }));
    }

    const changeDate = (date: Date | null, isStartDate: boolean = true): void => {
        if (date) {
            if (isStartDate) {
                setLicenseInfo({
                    ...licenseInfo,
                    startAt: DateParser.parseDateTime(date.toString(), true),
                    nextRenewalAt: licenseInfo.nextRenewalAt === "" ? DateParser.parseDateTime(date.toString(), false) : licenseInfo.nextRenewalAt
                });
            } else {
                setLicenseInfo({
                    ...licenseInfo,
                    startAt: licenseInfo.startAt === "" ? DateParser.parseDateTime(date.toString(), true) : licenseInfo.startAt,
                    nextRenewalAt: DateParser.parseDateTime(date.toString(), false)
                });
            }
        }
    }

    const onToggleClick = () => {
        setLicenseInfo(prevState => ({...prevState, isActive: !prevState.isActive}));
    }

    const onCapacityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (Number(event.target.value) >= 0) {
            setLicenseInfo(prevState => ({...prevState, capacity: Number(event.target.value) * 1024 ** 3}));
        }
    }

    const onCountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (Number(event.target.value) >= 0) {
            setLicenseInfo(prevState => ({...prevState, count: Number(event.target.value)}));
        }
    }

    const onSaveClick = () => {
        axios.post(UPDATE_LICENSE(props.userSeq), licenseInfo)
            .then(() => {
                props.setLicense(null);
            }).catch(error => console.log(error));
    }

    return (
        <div className="license-edit">
            <div className="box">
                <div className="title-wrapper">
                    <div className="title">
                        사용자 라이선스 수정
                    </div>
                    <div className="close-button" onClick={() => props.setLicense(null)}>
                        <img src={close} alt="close"/>
                    </div>
                </div>
                <div className="row-wrapper">
                    <div className="row">
                        <div className="row-title">
                            사용자 아이디
                        </div>
                        <div className="val-wrapper">
                            <input type="text" defaultValue={props.email} disabled/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="row-title">
                            라이선스
                        </div>
                        <div className="val-wrapper">
                            <input type="text"
                                   defaultValue={LicenseTypeList.find((license) => (license.type === licenseInfo.licenseType))?.name}
                                   disabled/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="row-title">
                            라이선스 활성화
                        </div>
                        <div className="val-wrapper">
                            <button className={`toggle-button ${licenseInfo.isActive ? "toggle-active" : ""}`}
                                    onClick={() => onToggleClick()}>
                                <div className="toggle"/>
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="row-title">
                            라이선스 기간
                        </div>
                        <div className="val-wrapper">
                            <DatePicker
                                className="date-picker"
                                name="expiredDate"
                                dateFormat="yyyy-MM-dd"
                                selected={licenseInfo.startAt ? new Date(licenseInfo.startAt) : null}
                                maxDate={getLimitDate(new Date(licenseInfo.startAt), new Date(licenseInfo.nextRenewalAt), true)}
                                locale={ko}
                                onChange={(date) => {
                                    changeDate(date)
                                }}
                                autoComplete="off"
                            />
                            ~
                            <DatePicker
                                className="date-picker"
                                name="expiredDate"
                                dateFormat="yyyy-MM-dd"
                                selected={licenseInfo.startAt ? new Date(licenseInfo.nextRenewalAt) : null}
                                minDate={getLimitDate(new Date(licenseInfo.startAt), new Date(licenseInfo.nextRenewalAt), false)}
                                locale={ko}
                                onChange={date => {
                                    changeDate(date, false)
                                }}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="row-title">
                            일일 제작 횟수
                        </div>
                        <div className="val-wrapper">
                            <input value={licenseInfo.count} type="number" onChange={e => onCountChange(e)}/> 회
                        </div>
                    </div>
                    <div className="row">
                        <div className="row-title">
                            저장 용량
                        </div>
                        <div className="val-wrapper">
                            <input value={licenseInfo.capacity / 1024 ** 3} onChange={e => onCapacityChange(e)}
                                   type="number"/> GB
                        </div>
                    </div>
                </div>
                <div className="button-wrapper">
                    <button className="cancel-button" onClick={() => props.setLicense(null)}>
                        취소
                    </button>
                    <button className="save-button" onClick={() => onSaveClick()}>
                        등록하기
                    </button>
                </div>
            </div>
        </div>
    )
}